import { ChevronsDownIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/shared/components/ui/tooltip'
import { cn } from '@/shared/lib/utils'

import { useScenarios } from './ScenariosProvider'
import SearchFilterField from './SearchFilterField'

export function ScenariosSidebarToolbar() {
	const { t } = useTranslation()

	const { isAllGroupsCollapsed, handleToggleAll } = useScenarios()

	return (
		<div className='flex items-center gap-2 border-b p-2'>
			<Tooltip>
				<TooltipTrigger asChild>
					<Button variant='ghost' size='icon-sm' onClick={handleToggleAll}>
						<ChevronsDownIcon
							className={cn(
								'transition-transform duration-200',
								isAllGroupsCollapsed && '-rotate-90'
							)}
						/>
					</Button>
				</TooltipTrigger>
				<TooltipContent>
					{t(
						isAllGroupsCollapsed ? 'general_expand_all' : 'general_collapse_all'
					)}
				</TooltipContent>
			</Tooltip>
			<SearchFilterField />
		</div>
	)
}
